// Lightweight logger that silently no-ops in production builds.
// Satisfies both "no empty catch" and "no console in production" rules.

const isProd = process.env.NODE_ENV === "production";

export const logger = {
  warn: (...args) => { if (!isProd) console.warn(...args); },
  error: (...args) => { if (!isProd) console.error(...args); },
  info: (...args) => { if (!isProd) console.info(...args); },
  // Use inside `catch` blocks where the failure is genuinely safe to swallow
  // (e.g. localStorage quota, network beacon). Provides a single audit log.
  silent: (label, err) => { if (!isProd) console.debug(`[silent:${label}]`, err); },
};
